const translations: Record<string, string> = {
  "ak_sld_normal": "Норма",
  "ak_sld_warning": "Попередження",
  "ak_sld_alarm": "Аварія",
  "ak_sld_no_link": "Немає звʼязку",
  "ak_sld_generating": "Генерує",
  "ak_sld_online_not_generating": "На звʼязку, без генерації",
  "ak_sld_temporary_link_loss": "Тимчасова втрата звʼязку",
  "ak_sld_running": "У роботі",
  "ak_sld_online": "На звʼязку",
  "ak_sld_min_ago": "{{n}} хв тому",
  "ak_sld_h_min_ago": "{{h}} год {{m}} хв тому",
  "ak_sld_no_link_last_data_at": "немає звʼязку · останні дані о {{c}}",
  "ak_sld_data_is_stale_received": "дані застаріли · отримано {{a}}",
  "ak_sld_alarm_2": "аварія «{{s}}»",
  "ak_sld_the_device_reported_an_alarm": "пристрій повідомив аварію «{{s}}»",
  "ak_sld_code": " (код {{c}})",
  "ak_sld_data_quality": "якість даних «{{q}}»",
  "ak_sld_the_collector_flagged_data_quality_ins": "колектор позначив якість даних «{{q}}» замість «ok»",
  "ak_sld_unknown_status": "невідомий стан «{{s}}»",
  "ak_sld_the_device_reported_an_unknown_status": "пристрій повідомив невідомий стан «{{s}}»",
  "ak_sld_alarm_3": "аварія{{s}}",
  "ak_sld_the_pcs_reported_an_active_alarm": "PCS повідомив активну аварію",
  "ak_sld_the_device_reported_an_alarm_2": "пристрій повідомив аварію{{s}}",
  "ak_sld_status": " · стан{{s}}",
  "ak_sld_more": " · ще {{n}}",
  "ak_sld_loading_data": "завантаження даних…",
  "ak_sld_no_data_from_the_telemetry_server": "немає даних від сервера телеметрії",
  "ak_sld_more_2": "ще {{n}}",
  "ak_sld_kw": "кВт",
  "ak_sld_mw": "МВт",
  "ak_sld_hz": "Гц",
  "ak_sld_mwh": "МВт·год",
  "ak_sld_mv": "мВ",
  "ak_sld_v": "В",
  "ak_sld_a": "А",
  "ak_sld_h": "год",
  "ak_sld_of_nominal": "від номіналу",
  "ak_sld_online_2": "на звʼязку",
  "ak_sld_bess": "УЗЕ · {{m}}",
  "ak_sld_racks_group": "Стійки {{r}} · Group {{g}}",
  "ak_sld_soc_vs_group": "ΔSoC з Group {{g}}",
  "ak_sld_group": "Група {{g}}",
  "ak_sld_group_2": "{{p}} · Група {{g}}",
  "ak_sld_p_estimate": "P · оцінка · {{d}}",
  "ak_sld_measurement": "Вимірювання:",
  "ak_sld_banks_racks": " · {{n}} × {{v}} {{s}} · {{b}} банків {{bv}} · {{r}} стійок",
  "ak_sld_ktp_inverters_panels": " · {{n}} КТП · {{i}} інверторів {{v}} {{m}} · панелі {{p}}",
  "ak_sld_banks": "Банки",
  "ak_sld_racks": "стійок",
  "ak_sld_racks_2": "Стійки",
  "ak_sld_from_pcs": "від PCS",
  "ak_sld_transformer": "Трансформатор",
  "ak_sld_inverters": "{{n}} інверторів {{v}} {{m}} · {{r}}",
  "ak_sld_group_3": "Група",
  "ak_sld_logger_plc_channel_plc_channel_number": "{{c}} — PLC-канал логера; {{p}} — номер PLC-каналу",
  "ak_sld_channel": "Канал",
  "ak_sld_breakers": "Вимикачі",
  "ak_sld_inverter": "Інвертор {{p}}, {{s}}",
  "ak_sld_not_in_the_logger_poll": "немає в опитуванні логера",
  "ak_sld_the_inverter_is_not_in_the_last_logger": "інвертора немає в останньому опитуванні логера",
  "ak_sld_no_link_2": "немає звʼязку",
  "ak_sld_data_is_stale": "дані застаріли",
  "ak_sld_data_quality_idle_in_daytime": "якість даних «idle» вдень",
  "ak_sld_the_collector_flagged_data_quality_idl": "колектор позначив якість даних «idle», хоча станція генерує",
  "ak_sld_not_in_the_poll": "немає в опитуванні",
  "ak_sld_the_pcs_is_not_in_the_last_bess_poll": "PCS немає в останньому опитуванні УЗЕ",
  "ak_sld_hover_over_a_device": "наведіть на пристрій",
  "ak_sld_no_deviations": "Без відхилень",
  "ak_sld_no_data": "немає даних",
  "ak_sld_just_now": "щойно",
  "ak_sld_discharge": "Розряд",
  "ak_sld_charge": "Заряд",
  "ak_sld_stopped": "Стоп",
  "ak_sld_standby": "Очікування",
  "ak_sld_inv": "інв.",
  "ak_sld_dev": "пристр.",
  "ak_sld_point_of_connection": "Точка приєднання",
  "ak_sld_estimate": "оцінка",
  "ak_sld_reason": "Причина",
  "ak_sld_pv_plant_sum_of_inverters": "СЕС (сума інверторів)",
  "ak_sld_inverter_data": "Дані інверторів",
  "ak_sld_bess_data": "Дані УЗЕ",
  "ak_sld_can_discharge": "Можна віддати",
  "ak_sld_can_charge": "Можна прийняти",
  "ak_sld_to_full_discharge": "До повного розряду",
  "ak_sld_to_full_charge": "До повного заряду",
  "ak_sld_cell_temperature_max": "Температура комірок, макс.",
  "ak_sld_data": "Дані",
  "ak_sld_mode": "Режим",
  "ak_sld_power": "Потужність",
  "ak_sld_load": "Навантаження",
  "ak_sld_temperature": "Температура",
  "ak_sld_allowed_charge_discharge": "Допустимо заряд / розряд",
  "ak_sld_device_status": "Стан пристрою",
  "ak_sld_logger_data": "Дані логера",
  "ak_sld_frequency": "Частота",
  "ak_sld_ac_power": "Потужність AC",
  "ak_sld_dc_power": "Потужність DC",
  "ak_sld_of_nominal_2": "Від номіналу",
  "ak_sld_deviations": "Відхилення",
  "ak_sld_none": "немає",
  "ak_sld_soc_between_groups": "ΔSoC між групами",
  "ak_sld_cell_temperature": "Температура комірок",
  "ak_sld_cell_voltage": "Напруга комірок",
  "ak_sld_voltage_current": "Напруга / струм",
  "ak_sld_the_power_at_the_point_of_connection_s": "Потужність у точці приєднання має вимірювати DIRIS A-30; кабінет його поки не опитує — це оцінка без втрат і власних потреб.",
  "ak_sld_export": "відпуск",
  "ak_sld_import": "приймання",
  "ak_sld_point_of_connection_pcc": "Точка приєднання (PCC)",
  "ak_sld_limit": "Ліміт",
  "ak_sld_frequency_inverters": "Частота · інвертори",
  "ak_sld_energy_storage_bess": "Накопичення енергії (УЗЕ)",
  "ak_sld_solar_generation": "Сонячна генерація",
};

export default translations;
